module.exports = __webpack_public_path__ + "img/8fd3f16.png";